<template>
    <div>
        <!-- Registro Avulso -->
        <div class="modal fade" id="novoRegistroAvulsoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="procedimentos_avulso">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecione o Procedimento</h5>
                        <button type="button" class="close" @click="fechar_modal_avulso()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="delegantes">
                            <div class="small text-muted">Em nome de...</div>
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" v-for="(deleg, idx) in delegantes" :key="idx" @click="novo_atendimento_avulso(deleg.delegante.id_pessoa)">
                                {{ deleg.delegante.search }}
                                </button>
                            </div>
                        </template>

                        <template v-else>
                            <az-input 
                                class="mb-2"
                                icon="far fa-calendar-plus fa-fw"
                                type="datetime-local"
                                required
                                :validate="validate"
                                v-model="dthr_avulso" />

                            <az-input
                                class="mb-2"
                                icon="fa fa-search fa-fw"
                                v-model="search_avulso" />

                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" v-for="(proc, ipx) in lista_procedimentos_avulsos" :key="ipx"
                                @click="salvar_avulso(proc)" :disabled="incluindo_avulso">
                                    {{ proc.search }}
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            validate: false, 
            delegantes: null, 
            procedimentos_avulso: [], 
            incluindo_avulso: false, 
            dthr_avulso: "", 
            search_avulso: "", 
            id: "", 
        }
    },

    components: { 
        AzInput, 
    }, 

    props: ['id_unidade_operacao'], 

    computed: { 
        lista_procedimentos_avulsos: function() { 
            if ( !this.procedimentos_avulso )
                return [];

            let pesquisar = this.search_avulso.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.procedimentos_avulso && this.procedimentos_avulso.length ? 
                this.procedimentos_avulso.filter (item => { 
                    return ( !this.search_avulso || reg.test(JSON.stringify(item)) );
                }) : null;
        }
    },

    methods: { 
        fechar_modal_avulso() { 
            $('#novoRegistroAvulsoModal').modal('hide');
        },

        novo_atendimento_avulso(id_medico_selecionado = null, id_paciente = null) { 

            if ( id_paciente ) { 
                this.id = id_paciente;
            }

            this.validate = false;
            
            $('[data-toggle="tooltip"]').tooltip("dispose");

            let id_medico = this.$store.state.user.id_pessoa;

            if ( !this.$store.state.user.medico ) { 

                if ( this.$store.state.user.delegantes_medicos && this.$store.state.user.delegantes_medicos.length == 1) { 

                    console.log(this.$store.state.user);
                    let id_teste = _.get(this.$store.state.user.delegantes_medicos, '0.delegante.id_pessoa');

                    if ( id_teste ) { 
                        id_medico = id_teste;
                    }

                } else if ( this.$store.state.user.delegantes_medicos && this.$store.state.user.delegantes_medicos.length > 1 ) { 

                    if ( !id_medico_selecionado ) { 

                        this.delegantes = this.$store.state.user.delegantes_medicos;
                        this.procedimentos_avulso = [];

                        $('#novoRegistroAvulsoModal').modal('show');

                        return

                    } else { 

                        id_medico = id_medico_selecionado;
                        this.id_medico_delegante = id_medico_selecionado;
                        this.delegantes = null;

                    }

                }

            }

            this.incluindo_avulso = true;

            this.$util.loadItem(this, { 
                service: 'medico_procedimento_unidades',
                func: 'index',
                parms: { 
                    id_medico: id_medico, 
                    avulso: true, 
                }
            })
            .then(res => { 
                this.procedimentos_avulso = res;
                this.dthr_avulso = this.$util.hoje() + 'T' + this.$util.agora().substr(0,5);

                if ( res.length ) { 

                    this.procedimentos_avulso.unshift({
                        id_procedimento: 1177,
                        search: "REGISTRO AVULSO",
                    });

                    this.$nextTick(() => { 
                        $('#novoRegistroAvulsoModal').modal('show');
                    });

                } else { 

                    this.salvar_avulso();

                }

            })
            .finally(() => { 
                this.incluindo_avulso = false;
            });

        },

        salvar_avulso(proc) {

            this.incluindo_avulso = true;

            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'incluir_avulso',
                dados: { 
                    id_paciente: this.id,
                    id_procedimento: proc ? proc.id_procedimento: null, 
                    data: this.dthr_avulso, 
                    id_medico_delegante: this.id_medico_delegante, 
                    id_unidade_operacao: this.id_unidade_operacao, 
                },
                callback: res => { 
                    this.incluindo_avulso = false;
                    $(".modal").modal("hide");

                    if ( this.$route.path.substr(0,17) == '/consultorio/res/' ) { 
                        this.$router.push({ name: "redir", params: { path: "/consultorio/res/" + res.id_atendimento } });
                    } else { 
                        this.$router.push({ path: "/consultorio/res/" + res.id_atendimento });
                    }
                },
                final: () => { 
                    this.incluindo_avulso = false;
                }
            });

        },

    }
    
}
</script>
